export default "__VITE_ASSET__c059a780__"